import React from 'react';
import './style.scss';


const MyMapComponent = () => {
    return (
      <div className='map-container'>
       <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2680.9726286474206!2d19.127699476707527!3d47.78197877585001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47402bada152befb%3A0x492a74b83d584a4a!2zVsOhY2kgQmVsdsOhcm9zaSBFZ8Opc3pzw6lnIEvDtnpwb250!5e0!3m2!1shu!2shu!4v1742410684121!5m2!1shu!2shu" 
       width="600" 
       height="450" 
       style={{ borderRadius: 10 , border: 0}}
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade">
        </iframe>
      </div>
    );
  };
  
  export default MyMapComponent;

 
